<template>
  <div class="activity-box">
    <div class="main">
      <img
        class="bg"
        src="https://resource.funplus.social/nicee-activity-image/constellation9-bg.png"
        alt=""
      />
      <div class="dressup1">
        <img src="https://resource.3uplay.com/sys-feed/091fb19f.webp" alt="" />
      </div>
      <div class="dressup2">
        <span>巨蟹守護～</span>
        <img src="https://resource.3uplay.com/sys-feed/913f5ebc.webp" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { reportPagelog as reportPagelogRequest } from '@/utils/report-page-log';
export default {
  name: 'ActivityBox',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {},
  methods: {
    reportPagelog() {
      const { path, query } = this.$route;
      const channel = query && query.pageFrom ? 0 : 1;
      reportPagelogRequest(path, this.uuid, channel);
    }
  },
  created() {
    this.reportPagelog();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #010119;
  background-image: url('./images/web-bg.jpg');
  background-size: 100% 100%;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      font-size: 0;
      top: 1906px;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 43px;
        color: white;
        z-index: 1;
      }
    }
    .dressup1 {
      left: 251px;
      img {
        width: 194px;
        height: auto;
      }
    }
    .dressup2 {
      left: 522px;
      top: 1946px;
      span {
        font-size: 20px;
        color: black;
        display: inline-block;
        text-align: center;
        width: 270px;
      }
      img {
        width: 270px;
        height: auto;
      }
    }
  }
}
</style>
